import { http } from '@/lib/http';
import type { APIResponse } from '@/types';

// お気に入り登録API呼び出し関数
export type PostFavoriteMaterialParams = {
  gfMaterialId: number;
};

export type PostFavoriteMaterialResponse = APIResponse<null>;

export const postFavoriteMaterial = async (params: PostFavoriteMaterialParams) => {
  try {
    const res = await http<PostFavoriteMaterialResponse>('/user/v1/gf/materials/favorite', {
      method: 'POST',
      body: JSON.stringify({
        gf_material_id: params.gfMaterialId,
      }),
    });
    return res;
  } catch (error) {
    console.error('postFavoriteMaterial Error', error);
    throw error;
  }
};
